import type { JSX } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { Button, Section } from "@impero-com/ui";
import type { MenuProps } from "antd";

import type { LegacyDataSheetOverview } from "api/legacy/model/legacyDataSheetOverview";
import { LegacyRoute } from "legacyRoutes";

import * as styles from "./ControlProgramDetailPage.css";
import { TileActionMenu } from "./TileActionMenu";

interface DataSheetsPanelProps {
    dataSheets: LegacyDataSheetOverview[];
    canEdit: boolean;
    controlProgramId: number;
    onRequestDelete: (dataSheetId: string) => void;
}

export function DataSheetsPanel({
    dataSheets,
    canEdit,
    controlProgramId,
    onRequestDelete,
}: DataSheetsPanelProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <div>
            <div className={styles.grid}>
                {dataSheets.map((dataSheet) => {
                    const items: MenuProps["items"] = [
                        {
                            key: "report",
                            label: (
                                <a
                                    href={`${LegacyRoute.REPORT_DATA_SHEET}?dataSheetId=${dataSheet.Id}`}
                                >
                                    {t(
                                        "ViewControlProgram_Control_DataSheetReport"
                                    )}
                                </a>
                            ),
                        },
                        ...(canEdit
                            ? [
                                  {
                                      key: "delete",
                                      danger: true,
                                      label: t("DataSheet_Delete"),
                                      onClick: () =>
                                          onRequestDelete(dataSheet.Id),
                                  },
                              ]
                            : []),
                    ];
                    return (
                        <Section
                            key={dataSheet.Id}
                            id={`datasheet-${dataSheet.Id}`}
                            className={styles.tile}
                        >
                            <div className={styles.header}>
                                <div className={styles.title}>
                                    {canEdit ? (
                                        <a
                                            href={`/v1/DataSheet/Edit/?dataSheetId=${dataSheet.Id}`}
                                            className={styles.titleLink}
                                        >
                                            {dataSheet.Name}
                                        </a>
                                    ) : (
                                        <span>{dataSheet.Name}</span>
                                    )}
                                </div>
                                <TileActionMenu items={items} />
                            </div>
                        </Section>
                    );
                })}
            </div>
            {canEdit && (
                <div className={styles.addButtonWrapper}>
                    <Button
                        size="default"
                        variant="primary"
                        onClick={() =>
                            (window.location.href = `/v1/DataSheet/Create?controlProgramId=${controlProgramId}`)
                        }
                    >
                        {t("ViewControlProgram_Add_DataSheet")}
                    </Button>
                </div>
            )}
        </div>
    );
}
